<template>
  <div class="upper-subpanel--inside">
    <div class="col-6">
      <DrugInfo/>
    </div>
    <div class="col-6">
      <ConfirmFlow 
        v-if="currentProgress === 'confirm'" 
        :confirmProgress="confirmProgress"
        v-on:confirmationFinish="getConfirmData"></ConfirmFlow>    
      <Loader v-if="currentProgress === 'finish'" />
    </div>
  </div>
</template>

<script>
import MultiFlowBase from '../ComponentBase/MultiFlowBase';
import DrugInfo from '../flowComp/DrugInfo';
import ConfirmFlow from './ConfirmFlow';
import Loader from '../common/Loader';

export default {
  name: 'multiFlow',
  extends: MultiFlowBase,
  props: [],
  data() {
    return {
    };
  },
  components: {
    DrugInfo,
    ConfirmFlow,
    Loader,
  },
  async mounted() {
    await this.$store.dispatch('fromFirstDrugInDevice');
  },
  methods: {
    getConfirmData() {
      this.nextProgress();
      if (this.nextDrugInDevice !== null) {
        // check whether next index is over the keys' array length
        console.log('get confirm data');
        this.$store.dispatch('toNextDrugInDevice');
        setTimeout(() => {
          this.resetProgress();
        }, 200);
      } else {
        console.log('leave multiflow');
        this.$emit('setAllConfirmData');
      }
    },
  },
  computed: {
    selectedDrugInDevice() {
      return this.$store.state.selectedDrugInDevice;
    },
  },
};
</script>



// WEBPACK FOOTER //
// MultiFlow.vue?62b7b874